module.exports = __webpack_public_path__ + "static/media/robo1.d3e95005.png";